module.exports = __webpack_public_path__ + "media/images/favicon-e9c237f4b76cbefef9102ab900068245.ico";